import { HeartHandshake, X, Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtNum } from "@/lib/format";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { BigButton } from "@/components/ui-kit";

export const CHARITY_VERSE = "مَّثَلُ الَّذِينَ يُنفِقُونَ أَمْوَالَهُمْ فِي سَبِيلِ اللَّهِ كَمَثَلِ حَبَّةٍ أَنبَتَتْ سَبْعَ سَنَابِلَ فِي كُلِّ سُنبُلَةٍ مِّائَةُ حَبَّةٍ ۗ وَاللَّهُ يُضَاعِفُ لِمَن يَشَاءُ ۗ وَاللَّهُ وَاسِعٌ عَلِيمٌ";
export const CHARITY_REF = "﴿البقرة ٢٦١﴾";

export const charityLine = (shop, t) => ({ product_id: null, name: `${t("charity")} · ${shop.charity_name || t("charity_default_name")}`, price: Number(shop.charity_amount) || 0, cost: 0, qty: 1, charity: true });

export function CharityDialog({ open, amount, currency, onAccept, onDecline }) {
  const { t, lang } = useApp();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onDecline()}>
      <DialogContent className="max-w-lg" data-testid="charity-dialog">
        <DialogTitle className="font-heading text-2xl flex items-center gap-2"><HeartHandshake className="w-7 h-7 text-[#1F9D55]" />{t("charity")} · <span dir="ltr">{fmtNum(amount)} {currency}</span></DialogTitle>
        <div className="rounded-2xl bg-[#F3FAF5] border border-[#1F9D55]/30 p-5 text-center">
          <p className="font-quran text-xl leading-loose text-[#0B2A5B]" dir="rtl" lang="ar" data-testid="charity-verse">{CHARITY_VERSE}</p>
          <p className="text-sm text-[#1F9D55] font-bold mt-2" dir="rtl">{CHARITY_REF}</p>
          {lang !== "ar" && <p className="text-xs text-muted-foreground mt-3">{t("charity_verse_tr")}</p>}
        </div>
        <p className="text-sm text-muted-foreground">{t("charity_ask_hint")}</p>
        <div className="grid grid-cols-2 gap-3">
          <BigButton variant="soft" onClick={onDecline} data-testid="charity-decline"><X className="w-5 h-5" />{t("charity_no")}</BigButton>
          <BigButton variant="green" onClick={onAccept} data-testid="charity-accept"><Check className="w-5 h-5" />{t("charity_yes")}</BigButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}
